/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { gatewaySessionsListFacets } from "../funcs/gatewaySessionsListFacets.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { GatewaySessionFacets } from "../models/components/gatewaysessionfacets.js";
import {
  ListGatewaySessionFacetsRequest,
  ListGatewaySessionFacetsSecurity,
} from "../models/operations/listgatewaysessionfacets.js";
import { unwrapAsync } from "../types/fp.js";
export type GatewaySessionFacetsQueryData = GatewaySessionFacets;

export function prefetchGatewaySessionFacets(
  queryClient: QueryClient,
  client$: GramCore,
  request?: ListGatewaySessionFacetsRequest | undefined,
  security?: ListGatewaySessionFacetsSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildGatewaySessionFacetsQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildGatewaySessionFacetsQuery(
  client$: GramCore,
  request?: ListGatewaySessionFacetsRequest | undefined,
  security?: ListGatewaySessionFacetsSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (
    context: QueryFunctionContext,
  ) => Promise<GatewaySessionFacetsQueryData>;
} {
  return {
    queryKey: queryKeyGatewaySessionFacets({
      gatewayId: request?.gatewayId,
      gramSession: request?.gramSession,
      gramKey: request?.gramKey,
    }),
    queryFn: async function gatewaySessionFacetsQueryFn(
      ctx,
    ): Promise<GatewaySessionFacetsQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(gatewaySessionsListFacets(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyGatewaySessionFacets(
  parameters: {
    gatewayId?: string | undefined;
    gramSession?: string | undefined;
    gramKey?: string | undefined;
  },
): QueryKey {
  return ["@gram/client", "gatewaySessions", "listFacets", parameters];
}
